import React from 'react';
import PropTypes from 'prop-types';

const EmptyPage = ({ title, children }) =>
  (<div className="empty-page">
    {title &&
      <h2>
        {title}
      </h2>}
    {children}
  </div>);

EmptyPage.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default EmptyPage;



// WEBPACK FOOTER //
// ./src/components/common/EmptyPage.js